export function loginWithoutAtSign(login:string | null): string {
  let l = login

  if (login && login.charAt(0) === '@') {
    l = login.substring(1)

    return l
  }

  return login ?? ''
}

export const atSignedLogin = (login: string): string => `@${ loginWithoutAtSign(login) }`

export const tgLoginLink = (login: string): string => `https://t.me/${ loginWithoutAtSign(login) }`
export const resolveTgLoginLink = (login: string): string => `tg://resolve?domain=${ loginWithoutAtSign(login) } }`
